import React from 'react'
import { useTranslate } from 'react-admin'

import LocalShippingRoundedIcon from '@material-ui/icons/LocalShippingRounded'
import CircularProgress from '@material-ui/core/CircularProgress'

import useDeliveryEvents from '../hooks/useDeliveryEvents'
import CardWithIcon from './CardWithIcon'

const TotalDeliveries = () => {
  const translate = useTranslate()
  const { loaded, total } = useDeliveryEvents()
  const subtitle = loaded ? total || 0 : <CircularProgress size={24} />

  return (
    <CardWithIcon
      type='success'
      icon={LocalShippingRoundedIcon}
      title={translate('messages.dashboard.totalDeliveries')}
      subtitle={subtitle}
    />
  )
}

export default TotalDeliveries
